// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".horizontal-scrollable-card[data-v-03ecf5ea]{overflow-x:auto;white-space:nowrap}", ""]);
// Exports
module.exports = exports;
